import { render, staticRenderFns } from "./Lang.vue?vue&type=template&id=bc5511b2&scoped=true"
import script from "./Lang.vue?vue&type=script&lang=js"
export * from "./Lang.vue?vue&type=script&lang=js"
import style0 from "./Lang.vue?vue&type=style&index=0&id=bc5511b2&prod&lang=scss"
import style1 from "./Lang.vue?vue&type=style&index=1&id=bc5511b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5511b2",
  null
  
)

export default component.exports